module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm-modal', {
    attrs: {
      "id": "applyModal"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.totalDivergence == 0 ? _vm.$t('conciliacaoManual.labels.conciliacaoDeLote') : _vm.$t('conciliacaoManual.labels.conciliacaoDeLoteDivergente'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.acaoFechar'),
      "customClass": "secondary",
      "id": "btnFecharModalAplicarLote",
      "clickFunction": _vm.closeModal,
      "disabled": _vm.disableButton
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "label": _vm.$t('conciliacaoManual.labels.acaoConfirmar'),
      "id": "btnConfirmacaoAplicarLote",
      "clickFunction": _vm.isJustification ? _vm.confirmJustify : _vm.confirmApplyAllotment,
      "disabled": _vm.disableButton
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ec141a1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec141a1a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/reports/manualConciliation/modals/applyModal.pug
// module id = 1469
// module chunks = 0